import { fontName as fontName_1 } from './fontName.locstring.json';
import loc from 'owa-localize';
import { callFormatApi } from 'owa-editor/lib/utils/callApi';
import PickerInputButtonBase from '../PickerInputButtonBase';
import { FONT_NAME_LIST, getLocalizedFontName } from 'owa-format-options';
import { FontPickerProps, FontNamePicker } from 'owa-editor-ribbon-secondary-ui';
import * as React from 'react';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const FONT_NAMES = FONT_NAME_LIST.map(font => getLocalizedFontName(font));
const DEFAULT_FONT_NAME = 'Calibri';

export default class FontNameWithInput extends PickerInputButtonBase {
    constructor() {
        super(
            'fontName',
            loc(fontName_1),
            FONT_NAMES,
            120 /*inputWidth*/,
            256 /*maxLength*/,
            true /*autoComplete*/
        );
    }

    onChange = (value: string) => {
        callFormatApi(this.editorViewState, 'setFontName', [value]);
    };

    normalizeValue = (value: string) => {
        const normalizedValue = FONT_NAME_LIST.filter(v => getLocalizedFontName(v) == value)[0];
        return normalizedValue?.family || value;
    };

    getCurrentValue = () => {
        return this.formatViewState.fontName || getDefaultFontName();
    };

    getPicker = (props: FontPickerProps) => {
        return <FontNamePicker {...props} />;
    };
}

function getDefaultFontName() {
    const userOption = getUserConfiguration().UserOptions;
    return userOption?.ComposeFontName || DEFAULT_FONT_NAME;
}
